import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    rotateWrapper: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      border: '2px solid rgba(134, 134, 241, 0.301961)',
      padding: 20,
      margin: '0 auto 60px',
      borderRadius: 5,
    },
    rotateTitle: {
      marginBottom: 0,
    },
    rotateIcon: {
      width: 40,
      marginRight: 15,
      animation: '$rotate 1.5s linear infinite',
      animationDirection: 'alternate',
    },
    '@keyframes rotate': {
      '0%': {
        transform: 'rotate(45deg)',
      },
      '100%': {
        transform: 'rotate(135deg)',
      },
    },
  }),
);

export default useStyles;
